import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthBridgeService } from '../services/auth-bridge.service';

// /login entry point. The in-app login page is no longer used under centralized
// auth — exchange an OAuth ?code callback (if returning from auth.crewdle.ai) or
// hand off to centralized auth. Already-signed-in users go to the dashboard.
export const loginRedirectGuard: CanActivateFn = async () => {
  const bridge = inject(AuthBridgeService).bridge;
  const router = inject(Router);

  const user = await bridge.ensureSession().catch(() => null);
  if (user) return router.parseUrl('/dashboard');

  await bridge.login();
  return false;
};
